module.exports = __webpack_public_path__ + "media/v2/components/HomePage/shared/PrizeSlider/img/secondary_2-0b806c84baa3156b8bed334803026534.png";